import { IProjectStatus } from '~/@api/generated-api-types-project/Api'
import type { ObjectValues } from '~/@lib/utils/type.utils'
import type { ProjectsItem } from '../_project_types/project.types'

const TABS = {
  FUNDED: 0,
  FINISHED: 1,
} as const

type TABS = ObjectValues<typeof TABS>

function projectsFilteredForCurrentTab(
  selectedTab: number,
  projects: Array<ProjectsItem>
) {
  if (selectedTab === TABS.FUNDED)
    return projects.filter(
      (project) => project.statusId === IProjectStatus.Funded
    )

  return projects.filter(
    (project) => project.statusId === IProjectStatus.Finished
  )
}

export { TABS, projectsFilteredForCurrentTab }
